import React from 'react';
import Modal from 'react-modal';
import './styles.scss';

const DeleteTaskModal = ({ closeModal, handleConfirm }) => {
  const handleClose = (e) => {
    e.stopPropagation();
    closeModal();
  };

  return (
    <Modal
      className="modal-alert delete-task-modal"
      isOpen
      onRequestClose={handleClose}
      contentLabel="Delete task modal"
      ariaHideApp={false}
    >
      <h2 className="modal-header">
        <img src="/images/alert-icon.svg" alt="" />
        <button className="btn btn-icon" onClick={handleClose}>
          <i className="icon-icon-x"></i>
        </button>
      </h2>

      <div>
        <h3>Confirm task deletion</h3>
        <p>This action is irreversible and will permanently remove all associated entities. </p>
      </div>
      <div className="modal-footer">
        <button className="btn btn-outline" onClick={handleClose}>
          Cancel
        </button>
        <button
          className="btn btn-danger"
          onClick={(e) => {
            e.stopPropagation();
            handleConfirm();
          }}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteTaskModal;
